module.exports = __webpack_public_path__ + "static/media/24-10.defd422b.mp3";